import { BaseContainerModel } from '../base-container.model';
import { bl_wms_grn_hdr_RowInterface, bl_wms_grn_hdr_RowClass, bl_wms_grn_line_RowClass, 
    bl_wms_grn_line_fi_gendoc_line_link_RowClass, bl_wms_grn_fi_xtn_gendoc_line_link_RowClass } from '../../dbschema/index';
export class WarehouseGrnContainerModel extends BaseContainerModel {
    bl_wms_grn_hdr: bl_wms_grn_hdr_RowInterface = new bl_wms_grn_hdr_RowClass();
    bl_wms_grn_line: bl_wms_grn_line_RowClass[] = [];
    bl_wms_grn_line_fi_gendoc_line_link: bl_wms_grn_line_fi_gendoc_line_link_RowClass[] = [];
    bl_wms_grn_fi_xtn_gendoc_line_link: bl_wms_grn_fi_xtn_gendoc_line_link_RowClass[] = [];
}
